import { motion } from "framer-motion";

export const MaskedText = ({ lines, className = "", lineClassName = "", lineClasses = [], delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClasses[i] || lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.05, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.14 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
